// utils/trackVisitedProduct.js
import axios from "axios";

const TrackVisitedProduct = async ({ productId, token }) => {
  try {
    await axios.post(
      "/visted",
      {
        productId,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  } catch (error) {
    console.error("Failed to track product visit:", error.message);
  }
};

export default TrackVisitedProduct;
